module.exports = __webpack_public_path__ + "img/front-bushes.b0e0d935.webp";